import React from 'react'

export default function MessageBold(props) {
  return (
    <svg
      width={props.width ? props.width : '24'}
      height={props.height ? props.height : '24'}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z'
        fill={props.color ? props.color : '#97A3C7'}
      />
      <path
        d='M16 13C16.5523 13 17 12.5523 17 12C17 11.4477 16.5523 11 16 11C15.4477 11 15 11.4477 15 12C15 12.5523 15.4477 13 16 13Z'
        fill={props.color ? props.color : '#97A3C7'}
      />
      <path
        d='M8 13C8.55228 13 9 12.5523 9 12C9 11.4477 8.55228 11 8 11C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13Z'
        fill={props.color ? props.color : '#97A3C7'}
      />
      <path
        d='M19.0706 4.93051C17.4298 3.27901 15.2642 2.25172 12.9472 2.02575C10.6302 1.79978 8.30695 2.38929 6.37799 3.69264C4.44903 4.996 3.03524 6.93152 2.38037 9.16552C1.7255 11.3995 1.87058 13.792 2.79061 15.9305C2.8865 16.1293 2.91796 16.353 2.88061 16.5705L2.00061 20.8005C1.9667 20.9627 1.97363 21.1307 2.02075 21.2896C2.06788 21.4484 2.15374 21.5931 2.27061 21.7105C2.36641 21.8056 2.48048 21.8803 2.60594 21.9302C2.7314 21.98 2.86565 22.004 3.00061 22.0005H3.20061L7.48061 21.1405C7.69814 21.1144 7.91873 21.1454 8.12061 21.2305C10.2591 22.1505 12.6516 22.2956 14.8856 21.6407C17.1196 20.9859 19.0551 19.5721 20.3585 17.6431C21.6618 15.7142 22.2513 13.3909 22.0254 11.0739C21.7994 8.75687 20.7721 6.5913 19.1206 4.95051L19.0706 4.93051ZM19.9006 13.2905C19.7051 14.4845 19.2413 15.6186 18.5442 16.6074C17.847 17.5963 16.9347 18.4141 15.8758 18.9994C14.8169 19.5847 13.639 19.9221 12.4308 19.9864C11.2227 20.0507 10.0156 19.8401 8.90061 19.3705C8.50515 19.2023 8.08034 19.1139 7.65061 19.1105C7.46289 19.1118 7.27559 19.1285 7.09061 19.1605L4.27061 19.7305L4.84061 16.9105C4.95413 16.2998 4.88095 15.669 4.63061 15.1005C4.161 13.9855 3.95041 12.7785 4.0147 11.5703C4.07898 10.3621 4.41647 9.18426 5.00175 8.12536C5.58703 7.06646 6.40486 6.15411 7.3937 5.45696C8.38254 4.75981 9.51662 4.29603 10.7106 4.10051C11.9639 3.89483 13.2481 3.99048 14.4571 4.37957C15.6661 4.76866 16.765 5.43999 17.6631 6.33805C18.5611 7.2361 19.2325 8.33506 19.6215 9.54403C20.0106 10.753 20.1063 12.0372 19.9006 13.2905Z'
        fill={props.color ? props.color : '#97A3C7'}
      />
    </svg>
  )
}
